import { render, staticRenderFns } from "./AddToHomeScreenIosBanner.vue?vue&type=template&id=192f53e0&scoped=true&"
import script from "./AddToHomeScreenIosBanner.vue?vue&type=script&lang=js&"
export * from "./AddToHomeScreenIosBanner.vue?vue&type=script&lang=js&"
import style0 from "./AddToHomeScreenIosBanner.vue?vue&type=style&index=0&id=192f53e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192f53e0",
  null
  
)

export default component.exports